import ArrowExpandFilled from './src/arrow-expand-filled';
export default ArrowExpandFilled;